import { isNil } from '@flowio/is';
import { AuthorizationsResource } from '@flowio/api-sdk';
import { AuthorizationsResource as InternalAuthorizationsResource } from '@flowio/api-internal-sdk';
var apiClientInstance;
var apiInternalClientInstance;

function getClientOptions() {
  return {
    fetch: window.fetch.bind(window)
  };
}

export function getApiClient() {
  if (isNil(apiClientInstance)) {
    apiClientInstance = {
      authorizations: new AuthorizationsResource(getClientOptions())
    };
  }

  return apiClientInstance;
}
export function getApiInternalClient() {
  if (isNil(apiInternalClientInstance)) {
    apiInternalClientInstance = {
      authorizations: new InternalAuthorizationsResource(getClientOptions())
    };
  }

  return apiInternalClientInstance;
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/services/index.js
// module id = 597
// module chunks = 0 1